export default __webpack_public_path__ + "static/media/makeup.34317a47.jpg";